import { useEffect, useState } from "react";
import Navbar from "../../Navbar/Navbar";
import CartItem from "../CartItem/CartItem";
import { useCartAdditionalData, useCart } from "../CartContext";
import { ShoppingCartItems } from "@/components/Cart/cart.dto";
import { useQuery } from "@tanstack/react-query";
import { fetchOrganization } from "@/api/OrganizationsAPI";
import LoadingElement from "@/components/Loading/LoadingElement";
import { toast } from "@/components/ui/use-toast";
import { fetchWorkingPoint } from "@/api/WorkingPointAPI";
import { getDecodedTokenDetails } from "@/components/Token/TokenService";
import { useNavigate } from "react-router-dom";

function CartPage() {
    const { setCartAdditionalData } = useCartAdditionalData();
    const [role, setRole] = useState('');
    // const {cart, removeFromCart, updateCartItemQuantity} = useCart();
    const { cart } = useCart();
    const { updateDeliveryMethodInCart } = useCart();

    const [cartItems, setCartItems] = useState<ShoppingCartItems | undefined>();
    const [workingPointId, setWorkingPointId] = useState<string | undefined>(undefined);
    const [deliveryMethod, setDeliveryMethod] = useState('');
    //const [showModalPickupTime, setShowModalPickupTime] = useState(false);
    const [pickupTime, setPickupTime] = useState("");
    const [userAtacFlow, setAtacFlowUser] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleCheckout = () => {
        navigate("/checkout", {
            state: { deliveryMethod, pickupTime },
        });
    };

    // useEffect(() => {
    //     if (deliveryMethod === "store") {
    //         setShowModalPickupTime(true);
    //     }
    // }, [deliveryMethod]);
    
    // const handleConfirm = () => {
    //     setShowModalPickupTime(false);
    // };
    
    useEffect(() => {
        setCartItems(cart?.items);
    }, [cart]);

    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    const userAtacFlow = tokenDetails.atacFlow;
                    setAtacFlowUser(userAtacFlow);
                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    const workingPointUser = tokenDetails.WPIDClaim.toString();
                    setCartAdditionalData({ workingPointId: workingPointUser });
                    setWorkingPointId(workingPointUser);
                    const userRole = tokenDetails.userRole;
                    setRole(userRole);
                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, [setCartAdditionalData]);

    useEffect(() => {
        if (deliveryMethod === null) return;

        const isPickup = deliveryMethod === "store";
        updateDeliveryMethodInCart(isPickup);
    }, [deliveryMethod]);

    const { data: dataWP, isLoading: isLoadingWP, error: errorWP } = useQuery({
        queryKey: ["workingPoint", workingPointId],
        queryFn: fetchWorkingPoint,
        enabled: !!workingPointId,
    });

    const { data, isLoading, error } = useQuery({
        queryKey: ["organization", dataWP?.organizationId],
        queryFn: fetchOrganization,
        enabled: !!dataWP?.organizationId,
    });

    if (!cart || !cart.items || (cart.items.stockItems?.length < 1 && cart.items.transitItems?.length < 1))
        return (
            <>
                <Navbar />
                <p className="text-xl pt-4 text-center">Cosul este gol.</p>
            </>
        );

    if (isLoading || isLoadingWP) return <p className="h-screen w-screen flex items-center justify-center"><LoadingElement /></p>;

    if (workingPointId === undefined) return <p>Nu exista date despre organizatie pe conturile de admin.</p>;
    if (error || errorWP || !data) {
        toast({ description: "Exista o eroare la preluarea informatiilor despre acest cont." });
        return <></>;
    }

    return (
        <>
            <div className="w-full">
                <Navbar />
            </div>

            <section>
                <div className="py-8 sm:px-6 sm:py-12 lg:px-8 w-full">
                    <div className="flex flex-col flex-wrap gap-4 ml-2">
                        <header className="text-center">
                            <h1 className="text-xl font-bold text-gray-900 sm:text-3xl">
                                Cosul tau
                            </h1>
                        </header>

                        <div
                            className="mt-8 flex flex-row flex-wrap justify-center lg:flex-nowrap px-4 gap-8 w-full overflow-x-auto"
                            style={{boxSizing: 'border-box'}}>
                            <div className="flex flex-col">
                                {cartItems?.transitItems?.length ? cartItems?.transitItems?.length > 0 &&
                                    <div>
                                        {/*{!userUM && <header className="text-left">*/}
                                        {/*    <h1 className="text-sm text-gray-900 mb-5 sm:text-3xl">*/}
                                        {/*        Produse in tranzit*/}
                                        {/*    </h1>*/}
                                        {/*</header>}*/}
                                        <ul key={cartItems?.transitItems?.length} className="space-y-4 flex-grow">
                                            {cartItems?.transitItems.map((el: any) => {
                                                return (
                                                    <CartItem
                                                        key={el.articleId}
                                                        productData={el.article}
                                                        itemData={el}
                                                    />
                                                );
                                            })}
                                        </ul>
                                    </div> : ""
                                }

                                {cartItems?.stockItems?.length ? cartItems?.stockItems?.length > 0 &&
                                    <div>
                                        {/*{!userUM && <header className="text-left">*/}
                                        {/*    <h1 className="text-sm text-gray-900 mt-12 mb-5 sm:text-3xl">*/}
                                        {/*        Produse in stoc*/}
                                        {/*    </h1>*/}
                                        {/*</header>}*/}
                                        <ul key={cartItems?.stockItems?.length} className="space-y-4 flex-grow">
                                            {cartItems?.stockItems.map((el: any) => {
                                                return (
                                                    <CartItem
                                                        key={el.articleId}
                                                        productData={el.article}
                                                        itemData={el}
                                                    />
                                                );
                                            })}
                                        </ul>
                                    </div> : ""
                                }
                            </div>

                            <div className="flex flex-col w-full lg:w-1/3">
                                {userAtacFlow && <div className="mb-4">
                                    <label htmlFor="deliveryMethod" className="flex flex-row justify-between">
                                          <span
                                              className="text-sm flex justify-between mx-5 font-medium text-gray-700 my-4">
                                            Metoda de livrare <span className="text-red-500 ml-0.5 mb-0.5">*</span>
                                          </span>

                                        <select
                                            name="deliveryMethod"
                                            id="deliveryMethod"
                                            className={`my-2 w-1/2 py-2 rounded border-gray-300 shadow-sm sm:text-sm mx-5 border-2 px-2 ${deliveryMethod === "" ? "text-red-500" : "text-black"}`}
                                            value={deliveryMethod}
                                            onChange={(e) => setDeliveryMethod(e.target.value)}
                                        >
                                            <option value="" className="text-red-500">Selecteaza optiunea dorita
                                            </option>
                                            <option value="store" className="text-black">Ridicare din magazin</option>
                                            <option value="delivery" className="text-black">Livrare</option>
                                        </select>
                                    </label>
                                </div>}

                                {/*{showModalPickupTime && (*/}
                                {/*    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">*/}
                                {/*        <div className="bg-white p-6 rounded shadow-md w-80">*/}
                                {/*            <h2 className="text-lg font-bold mb-4">Selectează intervalul orar pentru ridicarea din magazin</h2>*/}
                                
                                {/*            <div className="space-y-2">*/}
                                {/*                <label className="flex items-center space-x-2">*/}
                                {/*                    <input*/}
                                {/*                        type="radio"*/}
                                {/*                        name="pickupTime"*/}
                                {/*                        value="8:00-10:00"*/}
                                {/*                        checked={pickupTime === "8:00-10:00"}*/}
                                {/*                        onChange={(e) => setPickupTime(e.target.value)}*/}
                                {/*                    />*/}
                                {/*                    <span>8:00 - 10:00</span>*/}
                                {/*                </label>*/}
                                {/*                <label className="flex items-center space-x-2">*/}
                                {/*                    <input*/}
                                {/*                        type="radio"*/}
                                {/*                        name="pickupTime"*/}
                                {/*                        value="10:00-12:00"*/}
                                {/*                        className="text-red-500"*/}
                                {/*                        checked={pickupTime === "10:00-12:00"}*/}
                                {/*                        onChange={(e) => setPickupTime(e.target.value)}*/}
                                {/*                    />*/}
                                {/*                    <span>10:00 - 12:00</span>*/}
                                {/*                </label>*/}
                                {/*                <label className="flex items-center space-x-2">*/}
                                {/*                    <input*/}
                                {/*                        type="radio"*/}
                                {/*                        name="pickupTime"*/}
                                {/*                        value="12:00-14:00"*/}
                                {/*                        checked={pickupTime === "12:00-14:00"}*/}
                                {/*                        onChange={(e) => setPickupTime(e.target.value)}*/}
                                {/*                    />*/}
                                {/*                    <span>12:00 - 14:00</span>*/}
                                {/*                </label>*/}
                                {/*            </div>*/}
                                
                                {/*            <div className="flex justify-end mt-4">*/}
                                {/*                <button*/}
                                {/*                    onClick={handleConfirm}*/}
                                {/*                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"*/}
                                {/*                    disabled={!pickupTime}*/}
                                {/*                >*/}
                                {/*                    Confirma*/}
                                {/*                </button>*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*)}*/}

                                {/*{deliveryMethod === "store" &&*/}
                                {/*    <div className="flex justify-between mx-5 my-1">*/}
                                {/*        <dt>Intervalul de livrare ales</dt>*/}
                                {/*        <dd>{pickupTime ? pickupTime : "-"}</dd>*/}
                                {/*    </div>*/}
                                {/*}*/}
                                {data.isCreditLimitActive &&
                                    <div className="flex justify-between mx-5 my-1">
                                        <dt>Limita de credit</dt>
                                        <dd>{data?.overdraftValue} RON</dd>
                                    </div>
                                }
                                {data.isCreditLimitActive &&
                                    <div className="flex justify-between mx-5 my-1">
                                        <dt>Sold disponibil</dt>
                                        <dd>{data?.availableBalance} RON</dd>
                                    </div>
                                }

                                <div className="flex border-t border-gray-100 pt-4">
                                    <div className="w-full space-y-4">
                                        <dl className="space-y-0.5 text-sm text-gray-700">
                                            <div className="flex justify-between mx-5">
                                                <dt>Subtotal</dt>
                                                <dd>{cart.totals?.totalValueWithoutVat} RON</dd>
                                            </div>

                                            <div className="flex justify-between mx-5">
                                                <dt>VAT</dt>
                                                <dd>{cart.totals?.totalVatValue} RON</dd>
                                            </div>

                                            {deliveryMethod === "delivery" && cart.minimumValueTransportFee &&
                                                <div className="flex justify-between mx-5">
                                                    <dt>Taxa de transport</dt>
                                                    <dd>{cart.transportFeeValue} RON</dd>
                                                </div>}

                                            {/* <div className="flex justify-between">
                                                  <dt>Discount</dt>
                                                  <dd>-£20</dd>
                                                </div> */}

                                            <div className="flex justify-between !text-base font-medium mx-5">
                                                <dt>Total</dt>
                                                {/*{cartTotal && cartTotalVat &&*/}
                                                {/*    <dd>{(cartTotal + cartTotalVat).toFixed(2)} RON</dd>}*/}
                                                {deliveryMethod === "delivery" && cart.totals  ?
                                                    <dd>{cart.totals?.totalValueWithVat.toFixed(2)} RON</dd> :
                                                    <dd>{((cart.totals?.totalValueWithoutVat ?? 0) + (cart.totals?.totalVatValue ?? 0)).toFixed(2)} RON</dd>}
                                            </div>

                                            <div className="flex flex-col">
                                            {deliveryMethod === "delivery" && cart.transportFeeId && cart.totals?.remainingValueForNoTransportFee && cart.totals?.remainingValueForNoTransportFee > 0 ? <div
                                                className="flex justify-between !text-base font-medium mx-5 text-red-500 my-1">
                                                <span className="w-2.5 h-2 mt-2 rounded-full bg-red-500 mr-2"></span>Pentru
                                                a beneficia de transport GRATUIT, mai aveti {cart.totals?.remainingValueForNoTransportFee} lei pana la comanda minima.
                                            </div> : ""
                                            }

                                            {deliveryMethod === "delivery" && cart.transportFeeValue === 0 ? <div
                                                className="flex justify-between !text-base font-medium mx-5 text-green-500 my-1">
                                                <span className="w-2.5 h-2.5 mt-2 rounded-full bg-green-500 mr-2"></span>Beneficiezi de transport GRATUIT pentru aceasta comanda.
                                            </div> : ""
                                            }

                                            {deliveryMethod !== "" && userAtacFlow && cart.totals?.totalValueWithoutVat && cart.totals?.totalVatValue && data.isCreditLimitActive && (Number((cart.totals?.totalValueWithVat).toFixed(2)) > data?.availableBalance) ?
                                                <div
                                                    className="flex justify-between !text-base font-medium mx-5 text-red-500 my-1">
                                                    <span className="w-2 h-2 mt-2 rounded-full bg-red-500 mr-2"></span>Soldul
                                                    disponibil pentru plasarea comenzii este depasit
                                                    cu {((Number((cart.totals?.totalValueWithVat).toFixed(2))) - data?.availableBalance).toFixed(2)} RON.</div> : ""}

                                                {!userAtacFlow && cart.totals?.totalValueWithoutVat && cart.totals?.totalVatValue && data.isCreditLimitActive && (Number((cart.totals?.totalValueWithVat).toFixed(2)) > data?.availableBalance) ?
                                                    <div
                                                        className="flex justify-between !text-base font-medium mx-5 text-red-500 my-1">
                                                        <span className="w-2 h-2 mt-2 rounded-full bg-red-500 mr-2"></span>Soldul
                                                        disponibil pentru plasarea comenzii este depasit
                                                        cu {((Number((cart.totals?.totalValueWithVat).toFixed(2))) - data?.availableBalance).toFixed(2)} RON.</div> : ""}
                                            </div>
                                            
                                        </dl>

                                        <div className="mx-5">
                                            <DiscountsAppliedBadge/>
                                        </div>

                                        <div className="w-screen max-w-lg lg:max-w-md">
                                            {/* <WorkingPointsInfo /> */}
                                        </div>


                                        {role === "BASIC" && (
                                            <div className="w-2/4 mx-5 float-end text-center">
                                                <button
                                                    onClick={handleCheckout}
                                                    disabled={!deliveryMethod && userAtacFlow}
                                                    className="block w-full rounded bg-red-600 p-4 text-sm text-white font-medium"
                                                >
                                                    Plaseaza Comanda
                                                </button>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {process.env.REACT_APP_SHOW_MAINTENANCE_NOTIFICATION === 'true' &&
                <div className="fixed inset-x-0 bottom-0 p-4 z-20">
                    <div className="rounded-lg bg-red-600 px-4 py-3 text-white shadow-lg">
                        <p className="text-center text-sm font-medium">
                            {process.env.REACT_APP_MAINTENANCE_MESSAGE}
                        </p>
                    </div>
                </div>}
        </>
    );
}

function DiscountsAppliedBadge() {
    return (
        <>
            {/* <div className="flex justify-end">
                    <span className="inline-flex items-center justify-center rounded-full bg-indigo-100 px-2.5 py-0.5 text-indigo-700">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="-ms-1 me-1.5 h-4 w-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
                        />
                      </svg>
            
                      <p className="whitespace-nowrap text-xs">2 Discounts Applied</p>
                    </span>
              </div> */}
        </>
    );
}

export default CartPage;